const ClusterList = [
  {
    name: 'Да',
    value: true,
  },
  {
    name: 'Нет',
    value: false,
  },
]

export { ClusterList }
